import { InvoiceArrivalFilterValues } from "./types";

export const filterValuesToApiInput = (
  filterValues: InvoiceArrivalFilterValues
) => {
  let v = {};
  if (filterValues?.locationId?.length) {
    v = {
      ...v,
      locationId: {
        in: filterValues.locationId,
      },
    };
  }

  if (filterValues?.supplierId?.length) {
    v = {
      ...v,
      supplierId: {
        in: filterValues.supplierId,
      },
    };
  }

  if (filterValues?.productId?.length) {
    v = {
      ...v,
      productId: {
        in: filterValues.productId,
      },
    };
  }
  return v;
};
